export default __webpack_public_path__ + "static/media/tc13.7914afb4.png";